import { Component, OnInit } from '@angular/core';
import { User, SiteInductionInfo } from 'src/app/models/user.model';
import { Site } from 'src/app/models/site.model';
import { AuthService } from '@app/services/auth/auth.service';
import { SiteService } from '@app/services/site/site.service';
import { ConfigurationService } from '@app/services/configuration/configuration.service';
import { UserService } from '@app/services/user/user.service';
import { SiteInductionStatus } from 'src/app/shared/enums';

@Component({
    selector: 'app-induction-card-status',
    templateUrl: './induction-card-status.component.html',
    styleUrls: ['./induction-card-status.component.scss'],
    standalone: false
})
export class InductionCardStatusComponent implements OnInit {
  readonly SiteInductionStatus = SiteInductionStatus;
  currentUser: User | undefined;
  currentSite: Site | undefined;
  selectedSiteInductionInfo: SiteInductionInfo | undefined;
  profileInductionRequired: boolean = false;
  hasActiveBrandInductionConfig: boolean = false;

  get visitorCardAvailable(): boolean {
    return this.profileInductionRequired && this.hasActiveBrandInductionConfig;
  }

  constructor(
    private _authService: AuthService,
    private _siteService: SiteService,
    private _configurationService: ConfigurationService,
    private _userService: UserService
  ) {}

  ngOnInit(): void {
    this._configurationService.getProfileInductionRequired()
      .then(value => { this.profileInductionRequired = value; });

    this._siteService.getSignedInSite().then(site => {
      this.currentSite = site;
      if (site?.brand?.id) {
        const brandId = site.brand.id;
        this._userService.getBrandInductionConfigs().subscribe({
          next: configs => {
            this.hasActiveBrandInductionConfig = !!(configs && configs.some(
              c => c.brand?.isActive && c.brand?.id === brandId));
          }
        });
      }
    });

    this._authService.getUser().then(user => {
      this.currentUser = user;
      const list = user.siteInductionInfos;
      const filtered = list.filter(sii => sii.brandId === this.currentSite?.brand?.id);
      this.selectedSiteInductionInfo = filtered.length === 1 ? filtered[0] : undefined;
    });
  }
}
